import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './info-constants';
import * as actions from './info-actions';

export function* getCustomerInfo(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `info/customer/${action.payload.id}`,
      options: {
        errorMessage: `Could not get customer details ${action.payload.id}`,
        retryAction: action,
      },
    });
    yield put(actions.getCustomerInfoSuccess(results));
  } catch (err) {
    yield put(actions.getCustomerInfoFailure(err));
  }
}

function* watchGetCustomerInfo() {
  yield takeLatest(types.GET_CUSTOMER_INFO_REQUEST, getCustomerInfo);
}

export default [fork(watchGetCustomerInfo)];
